import { HttpClient } from '@shared/adapters/HttpClient';

export interface StockLocationCart {
    location_id: number;
    product_id: number;
    qty: number;
    returned_reception_id: number | null;
    preparation_id: number | null;
    merchandise_id: number | null;
    location_order_id: number | null;
    product?: {
        id: number;
        name: string;
        image?: string;
        code: string;
    };
}

export interface Cart {
    id: number;
    code: string;
    team_id: number;
    type_id: number;
    type?: {
        id: number;
        name: string;
    };
    is_locked: boolean;
    stock: number;
    stock_location_carts: StockLocationCart[];
    created_at: string;
}

export interface CartApiResponse {
    data: Cart[];
    meta: {
        total: number;
        perPage: number;
        currentPage: number;
        lastPage: number;
    };
}

export class CartApiAdapter {
    constructor(private httpClient: HttpClient) { }

    /**
     * Busca un carrito por código
     */
    async searchByCode(code: string): Promise<Cart | null> {
        const response = await this.httpClient.get<CartApiResponse>('/carts', {
            search: code.trim(),
        });

        // Buscar coincidencia exacta por código
        const cart = response.data.find(
            (c) => c.code.toLowerCase() === code.toLowerCase().trim()
        );

        return cart || null;
    }
}

